export default "__VITE_ASSET__jwgfi$pU__"